<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="list">
          <router-link :to="{path:'/NewsA1Detail/'+item.id}" tag="div" class="item" :key="index" v-for="(item,index) in dataList">
            <div class="date">
              <span>{{parseTime(new Date(item.addTime),'{d}')}}</span>
              <span>{{parseTime(new Date(item.addTime),'{y}-{m}')}}</span>
            </div>
            <div class="text">
              <div class="title text-hide">{{item.title}}</div>
              <div class="info" v-html="item.detail"></div>
            </div>
            <div class="more">{{$t('otherPage.p9')}}</div>
          </router-link>
          <div style="clear: both"></div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[5, 10, 15, 20, 25]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="config.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api"
  // import {getNewsA1} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";
  import {mixin} from '@/mixin/index'

  export default {
    name: "List",
    mixins:[mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        config: {
          classify: '',
          total: 0,
          page: 1,
          limit: 5
        },
        dataList:[]
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        // 获取数据
        this.toGetData()
      }
    },
    created(){
      // 获取数据
      this.toGetData()
    },
    methods:{
      // 获取数据
      async toGetData(val) {
        this.dataList = []
        let params = {
          pageNum: this.config.page,
          pageSize: this.config.limit,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "通知公告",
          articleKey:"cms",
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows,total}} = await getSingle(params)
        console.log(rows,total)
        rows.forEach( val => {
          this.dataList.push({
            id : val.id,
            title : val.smallTitle,
            detail: val.bigTitle,
            addTime:val.createTime,
          })
        })
        this.config.total = total
      },
      // toGetData() {
      //   getNewsA1(this.config).then((res) => {
      //     this.dataList = res.data.data.list
      //     this.config.total = res.data.data.count
      //   })
      // },
      // 分页事件
      handleSizeChange(val) {
        this.config.limit = val
        this.toGetData()
      },
      handleCurrentChange(val) {
        this.config.page = val
        this.toGetData()
      }
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }
  .container{
    .wrap{
      width: 1380px;
      background: #FFFFFF;
      margin: 0 auto 100px;
      .list{
        width: 100%;
        .item {
          width: 100%;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          height: 170px;
          background: #F6F8FA;
          margin-top: 30px;
          position: relative;
          .text{
            width: 1222px;
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: relative;
            .title{
              font-family: PingFangSC;
              font-weight: 600;
              font-size: 28px;
              color: #333333;
              width: 968px;
            }
            .info{
              width: 960px;
              font-family: Source Han Sans CN;
              font-size: 20px;
              color: #666666;
              line-height: 32px;
              margin-top: 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              height: 36px;
              text-align: justify;
            }
          }
          .more{
            position: absolute;
            content:"查看详情";
            top: 50%;
            right: 30px;
            transform: translateY(-50%);
            width: 128px;
            height: 40px;
            border-radius: 20px;
            border: 1px solid #DA1E2D;
            line-height: 38px;
            text-align: center;
            font-family: SourceHanSans;
            font-size: 18px;
            color: #DA1E2D;
            transition: .3s;
          }
          .date{
            width: 128px;
            padding-left: 30px;
            padding-right: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: relative;

            span:nth-child(1){
              line-height: 1;
              margin-bottom: 12px;
              font-weight: bold;
              font-size: 48px;
              color: #DA1E2D;
            }
            span:nth-child(2){
              font-size: 20px;
              color: #555555;
            }
            &:after{
              content: "";
              width: 1px;
              height: 90px;
              background: #CAD0D5;
              position: absolute;
              right: 0;
              top: 50%;
              -webkit-transform: translateY(-50%);
              transform: translateY(-50%);
            }
          }

        }
        .item:hover .more{
          background:#DA1E2D;
          color: #fff;
        }
        .item:nth-child(1){
          margin-top: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/News/A1/List.vue